var root = document.body;
var playerUrls = {
    live: '/player/live',
    video: '/player/kijk',
    archief: '/player/archief',
    newsbulletin: '/player/nieuwsbulletin?s_cid=nb-bulletin-homepage'
};
root.addEventListener('click', function (e) {
    if (e.target.closest('.launch-player')) {
        e.preventDefault();
        var el = e.target.closest('.launch-player');
        var type = el.getAttribute('data-type');
        var audioid = el.getAttribute('data-id');
        var articleid = el.getAttribute('data-articleid');
        var url = playerUrls[type] || playerUrls.live;
        if (audioid) {
            url = "/player/audio/" + audioid + "/" + articleid;
        }
        var playerWindow = window.open(url, "_blank", "width=380,scrollbars=1,height=" + (window.screen.height - 100));
        playerWindow.moveTo(20, 20);
    }
}, false);
